import { render, staticRenderFns } from "./PrintPDF.vue?vue&type=template&id=7467856c&lang=pug"
import script from "./PrintPDF.vue?vue&type=script&lang=js"
export * from "./PrintPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports